import DashCalculator from './DashCalculator';

function App() {
  return (
    <div className='App'>
      <DashCalculator />
    </div>
  );
}

export default App;
